export default __webpack_public_path__ + "static/media/mail.9c7d815d.svg";